const StoredEntity = require('./stored-entity');
const RequestPackageStep = require('./packagestep');

class RequestPackage extends StoredEntity {

	constructor() {
		super();
		this.steps = [];	//embedded
		this.createRequestButtonLabels = [];	//here of classification
		this.requestTitleLabels = [];			//here of classification
	}

	getSteps() {
		return this.steps;
	}

	getStep(n) {
		if (!this.steps[n]) throw new Error(`out of bounds step: ${n}`);
		return this.steps[n];
	}

	getStepByRole(r) {
		let step = this.steps.find(s => s.role === r);
		if (!step) throw new Error('no step for this role: '+r);
		return step;
	}

	getFieldById(id) {
		for (let step of this.steps) {
			for (let field of step.getFieldsLoaded()) {
				if (field.getId() === id) return field;
			}
		}
		throw new Error('cannot find field: '+id);
	}

	toStorage() {
		let data = super.toStorage();
		data.steps = data.steps.map(s => s.toStorage());
		return data;
	}

	fromData(data) {
		super.fromData(data);
		this.steps = data.steps.map(sd => {
			let step = new RequestPackageStep(this);
			step.fromData(sd);
			return step;
		});
	}
}

module.exports = RequestPackage;
